import AnimatedComponent from '../abstracts/AnimatedComponent';

export default class FormComponent extends AnimatedComponent {
    constructor(compEl) {
        super(compEl);
    }

    init() {
        super.init();
    }
}
